<script>
import { firebase } from '@firebase/app'
import '@firebase/firestore'
import moment from 'moment'
import _ from 'lodash'
export default {
  getMessage: field => `Giá trị của ${field} đã bị trùng trong bảng, vui lòng chọn giá trị không trùng`,
  validate (value, { runRule, fieldName, dataType, config, rootModel } = {}) {
    if (runRule) {
      if (dataType === 'timestamps') {
        value = typeof value === 'object' ? _.cloneDeep(value) : _.cloneDeep(firebase.firestore.Timestamp.fromDate(moment(value, config.format).toDate()))
      }
      if (rootModel instanceof Array) {
        return !_.find(rootModel, item => _.isEqual(value, item[fieldName]))
      } else if (rootModel instanceof Object) {
        for (let index in rootModel) {
          let finded = _.find(rootModel[index], item => _.isEqual(item[fieldName], value))
          if (finded) {
            return false
          }
        }
      }
    return true
    }
  }
}
</script>
